<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/8m1pRV/tc-custom/9780226389394.jpg?1731798794275" alt="This image is the cover for the book What Is Education?"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">What Is Education?
      </h1>
      <p class="bookDescription body article font2">
        <p>One day in 1938, John Dewey addressed a room of professional educators and urged them to take up the task of “finding out just what education is.” Reading this lecture in the late 1940s, Philip W. Jackson took Dewey’s charge to heart and spent the next sixty years contemplating his words. The stimulating result of a lifetime of thinking about educating, <i>What Is Education?</i> is a profound philosophical exploration of how we transmit knowledge in human society and how we think about accomplishing that vital task. Most contemporary approaches to education follow a strictly empirical track, aiming to discover pragmatic solutions for teachers and school administrators. Jackson argues that we need to learn not just how to improve on current practices but also how to think about what education means—in short, we need to answer Dewey by constantly rethinking education from the ground up. Guiding us through the many facets of Dewey’s comments, Jackson also calls on Hegel, Kant, and Paul Tillich to shed light on how a society does, can, and should transmit truth and knowledge to successive generations. Teasing out the implications in these thinkers’ works ultimately leads Jackson to the conclusion that education is at root a moral enterprise. At a time when schools increasingly serve as a battleground for ideological contests, <i>What Is Education?</i> is a stirring call to refocus our minds on what is for Jackson the fundamental goal of education: making students as well as teachers—and therefore everyone—better people.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Philip W. Jackson
      </h2>
      
      <p class="authorDescription body article"><P><B>Philip W. Jackson&#160;</B>(1929–2015)&#160;was the David Lee Shillinglaw Distinguished Service Professor Emeritus in the Departments of Education and Psychology and in the College at the University of Chicago. He is the author of several books, including&#160;<I>Life in Classrooms</I>,&#160;<I>The Practice of Teaching</I>, and&#160;<I>John Dewey and the Philosopher’s Task</I>.</P><br></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?22170ca4